const DEFAULT_ZOOM_CLAMP_MULTIPLIER = 2.5;
const MOBILE_NEW_UI_ZOOM_CLAMP_MULTIPLIER = 4;
export function getGameWorldZoomClampMultiplier(isUserOnMobileAppOrWeb, shouldDisplayNewMobileGameUI) {
    if (isUserOnMobileAppOrWeb && shouldDisplayNewMobileGameUI) return MOBILE_NEW_UI_ZOOM_CLAMP_MULTIPLIER;
    return DEFAULT_ZOOM_CLAMP_MULTIPLIER;
}
export const MOBILE_ZOOM_BOOST = 1.1;
export const CANVAS_CARD_RATIO = 400 / 285;
export const TILE_RATIO = 400 / 346;
